import React from 'react';

import { View } from 'react-native';
import { StyleSheet } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { StyledLoyaltyPointsIcon } from 'components/loyalty-points-button/styled';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

export const HeaderPoints = React.memo(() => {
  const availablePoints = useAppSelector(selectors.loyalty.selectStagedCartPoints);

  return (
    <View style={styles.container} accessibilityLabel={`${String(availablePoints)} ${t('points')}`}>
      <Typography variant="headerFourLook" style={styles.text}>
        {String(availablePoints)}
      </Typography>
      <StyledLoyaltyPointsIcon reversed={false} />
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: spacing.$15,
  },
  text: {
    color: primitive.$mayoEggWhite,
    marginBottom: 0,
    marginRight: spacing.$2,
  },
});
